import { useAuthStore, useSideNavStore } from '../../store';
import React from 'react';
import { Layout, Menu, MenuProps } from 'antd';
import { filterItemsByUser, items } from './SideMenuItems';
import AppBrandHeader from './AppBrandHeader';
import { Link } from 'react-router-dom';

const { Sider } = Layout;
const AppSideMenu = () => {
  const sideNav = useSideNavStore();
  const { user } = useAuthStore();

  const side: MenuProps['items'] = filterItemsByUser(items, user).flatMap(
    (item) => {
      if (item !== null) {
        return item.children == null
          ? [
              {
                label: (
                  <>
                    <p>{item.label}</p>
                    <Link key={item.key} to={item.url} />
                  </>
                ),
                key: item.key || '',
                icon: item.icon,
              },
            ]
          : [
              {
                label: (
                  <>
                    <p>{item.label}</p>
                    <Link key={item.key} to={item.url} />
                  </>
                ),
                key: item.key || '',
                icon: item.icon,
                children: item.children.flatMap((child) =>
                  child?.children
                    ? [
                        {
                          label: (
                            <>
                              <p>{child.label}</p>
                              <Link key={child.key} to={child.url} />
                            </>
                          ),
                          key: child.key || '',
                          icon: child.icon,
                          children: child.children.map((grandChild) => ({
                            label: (
                              <>
                                <p>{grandChild?.label}</p>
                                <Link
                                  key={grandChild?.key}
                                  to={grandChild!.url}
                                />
                              </>
                            ),
                            key: grandChild?.key || '',
                            icon: grandChild?.icon,
                          })),
                        },
                      ]
                    : [
                        {
                          label: (
                            <>
                              <p>{child?.label}</p>
                              <Link key={child?.key} to={child!.url} />
                            </>
                          ),
                          key: child?.key || '',
                          icon: child?.icon,
                        },
                      ],
                ),
              },
            ];
      } else {
        return [];
      }
    },
  );

  return (
    <Sider
      width={256}
      style={{
        position: 'fixed',
        left: 0,
        height: '100vh',
        overflow: 'auto',
      }}
      trigger={null}
      collapsible
      collapsed={sideNav.isCollapse}
      onCollapse={(value) => sideNav.setCollapse(value)}
      theme={'light'}
    >
      <AppBrandHeader collapsed={sideNav.isCollapse} />
      <Menu
        style={{ marginTop: '20px' }}
        theme="light"
        defaultSelectedKeys={[sideNav.selectedKey]}
        selectedKeys={[sideNav.selectedKey]}
        mode="inline"
        items={side}
      />
    </Sider>
  );
};
export default AppSideMenu;
